
  // 功能：抢到类型汇总类
  // 作者：zmf
  // 时间：2020年07月16日 14:19:11
  // 版本：v1.0
  // 修改记录：
  // 修改内容：
  // 修改人员：
  // 修改时间：
/*** USER_TYPE 内部逻辑判断，不作为服务端返回数据判断，也不作为发送服务端数据类型判断。发送、接收的类型，单个类自定义 **/
const USER_TYPE = {TEACHER_TYPE:2,STUDENT_TYPE:1,HEIGHT_AUTH:3,HAS_STUDENT_ROLE:1,HAS_STUDENT_NO_ROLE:0};
const SEX_TYPE = {MALE:0,FEMALE:1};
const RUSH_TYPE = {SUCCESS:1,NOTHING:2,END:3,FAIL:4};

//       WAITE : 0,		// 0 未开始
// 	   SIGN : 10,		// 10 签到
// 	   RE_SIGN :  11,	// 11 再次签到，之前有上课记录
// 	   IN_CLASS : 20,	// 20 上课中
// 	   QUESTION : 21,	// 21 提问
// 	   GROUP : 23,		// 23 分组中
// 	  // ============= 讨论 start ============
// 	   DISCUSS : 22,	// 22 分组讨论
// 	   FREE_DISCUSS : 25,	// 25自由讨论
// 	   DISCUSS_PAUSE : 24,	// 24 分组讨论暂停
// 	   FREE_DISCUSS_PAUSE : 26,	// 26 自由讨论暂停
// 	  // ============= 讨论 end ===============
// 	   RUSHING : 27,	// 27 抢答中
// 	   RUSH_SCORE : 28,	// 28抢答加分
// 	   OUT_CLASS : 30	//30 课下
const STATUS = {
  WAITE: 0, SIGN: 10, RE_SIGN: 11, IN_CLASS: 20, QUESTION: 21, GROUP: 23, DISCUSS: 22, FREE_DISCUSS: 25,
  ISCUSS_PAUSE: 24, FREE_DISCUSS_PAUSE: 26, RUSHING: 27, RUSH_SCORE: 28, OUT_CLASS: 30
};
//////////////////////////////// signStatus //////////////////////////////////////////
//zmf 标注：正常
const SIGNSTATE = {
    STUDENT_NO_SIGHT : -1,
	STUDENT_NORMAL_CLASS_STATE : 0,
    //zmf 标注：缺🎹
	STUDENT_OUT_OF_CLASS_STATE : 1,
     //zmf 标注：请假
	STUDENT_LEAVE_CLASS_STATE : 2
};

//////////////////////////////////////////////////////////////////////////////////
// 授权认证时使用的状态，首先挑选当前的角色(role：student，teacher)，其次选择当前所走的流程(如身份认证)
const AUTH_TYPE = {
  ROLE_STUDENT: 1 << 0,
  ROLE_TEACHER: 1 << 1,
  TYPE_IDENTITY_VERIFY: 1 << 2,
}

const BUS_EVENT = {
  CLASS_IN_TASK_CLOSE : 'class_in_task_close' // 课上任务关闭
}

export default {
  USER_TYPE,
  SEX_TYPE,
  RUSH_TYPE,
  STATUS,
  AUTH_TYPE, SIGNSTATE,BUS_EVENT
}



// WEBPACK FOOTER //
// ./src/data/AppTypeData.js